// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PqDrd","logo":"styles_logo__mHGYC","title":"styles_title__y-7J3","text":"styles_text__QBM4J","space":"styles_space__fNnZM"};